import React, { Component } from "react";
class GenericException extends Component {
  state = {};
  render() {
    return <div></div>;
  }
}

export default GenericException;
